<template>
    <div>
        <b-row>
            <b-col
                ><app-sub-title
                    text="Envío de Mensaje a puestos de vigilancia"
                ></app-sub-title
            ></b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-input
                    v-model="message.subject"
                    label="Asunto"
                    :has-error="$v.message.subject.$error"
                    @input="$v.message.subject.$touch()"
                    error-message="Debe diligenciar el asunto"
                ></app-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-textarea-input
                    v-model="message.message"
                    label="Mensaje"
                    :has-error="$v.message.message.$error"
                    @input="$v.message.message.$touch()"
                    error-message="Debe diligenciar el mensaje"
                ></app-form-textarea-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-checkbox value="1" v-model="message.requireResponse"
                    >Requiere respuesta</b-form-checkbox
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-service-spot-messages-client-selector
                    v-model="destinataries"
                    ref="client-selector"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col class="d-flex justify-content-end">
                <b-btn variant="secondary" @click="$router.go(-1)" class="mr-2"
                    ><i class="fa fa-times"></i> Cancelar</b-btn
                >
                <b-btn
                    variant="primary"
                    @click="send"
                    :disabled="!destinataries.length || inProgress"
                    ><i class="fa fa-envelope"></i> Enviar</b-btn
                >
            </b-col>
        </b-row>
    </div>
</template>
<script>
import appServiceSpotMessagesClientSelector from './ServiceSpotMessagesClientSelector'
import { required } from 'vuelidate/lib/validators'
export default {
    components: {
        appServiceSpotMessagesClientSelector,
    },
    data: () => ({
        message: {
            subject: '',
            message: '',
            requireResponse: '0',
        },
        destinataries: [],
    }),
    validations: {
        message: {
            subject: { required },
            message: { required },
        },
    },
    computed: {},
    methods: {
        async send() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error('Debe diligenciar los datos del mensaje')

            if (this.destinataries.length === 0)
                return toastr.error(
                    'Debe seleccionar al menos un puesto de trabajo'
                )

            const payload = {
                message: { ...this.message, createdById: this.user.id },
                destinataries: this.destinataries,
            }
            const { data } = await repo.post(
                'service-spot-messages/send',
                payload
            )

            if (data.status) {
                toastr.success('Mensaje enviado')
                this.reset()
            } else {
                toastr.error(data.msg)
            }
        },
        reset() {
            this.message.subject = ''
            this.message.message = ''
            this.message.requireResponse = '0'
            this.$refs['client-selector'].reset()
            this.$v.$reset()
        },
    },
}
</script>
